import { useLocation } from 'react-router';
import { CreatePermanentJobPostingSteps } from '../Types';

export const useCurrentPermanentJobPostingSlug = (): CreatePermanentJobPostingSteps | undefined => {
  const { pathname } = useLocation();

  return (pathname.split('/').pop() as CreatePermanentJobPostingSteps) ?? undefined;
};
